import colleague from './colleague'
import edm from './edm'
import card from './card'
import tool from './tool'
import admin from './admin'
import note from './note'
import task from './task'
import crmCb from './crm'
import message from './message'
import ai from './ai'
import help from './help'

export default {
  path: '',
  component: () => import('../../layouts/inner'),
  children: [colleague, edm, card, tool, admin, note, task, crmCb, message, ai, help]
}
